import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const SecuritySettings: React.FC = () => {
  return (
    <Card>
      <Title level={4}>Security Settings</Title>
      <p>Configure password policies, session management, and security features.</p>
      <p>Manage two-factor authentication, IP restrictions, and audit logging.</p>
    </Card>
  );
};

export default SecuritySettings; 